__turbopack_context__.v({
  "close": "layout-modal-module-scss-module__SoqsSG__close",
  "content": "layout-modal-module-scss-module__SoqsSG__content",
  "header": "layout-modal-module-scss-module__SoqsSG__header",
  "modal": "layout-modal-module-scss-module__SoqsSG__modal",
  "modal--close": "layout-modal-module-scss-module__SoqsSG__modal--close",
  "modal--open": "layout-modal-module-scss-module__SoqsSG__modal--open",
  "overlay": "layout-modal-module-scss-module__SoqsSG__overlay",
  "overlay--close": "layout-modal-module-scss-module__SoqsSG__overlay--close",
  "overlay--open": "layout-modal-module-scss-module__SoqsSG__overlay--open",
});
